// src/components/common/AppVersionLabel.js
//
// Shared, reusable label that displays the current app version.
// The version number itself comes from src/config/version.js (which in
// turn is sourced from package.json), so this component never needs to
// change when the version is bumped - only package.json does.
//
// By default this renders the full "Version X.X.X" text (used e.g. on
// the Login page footer, standalone). Pass `showLabel={false}` when the
// consuming page already provides its own label text (e.g. Company
// Settings, which follows a "Label: <strong>value</strong>" pattern) -
// in that case only the version number itself is rendered.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { APP_VERSION } from '../../config/version';

const AppVersionLabel = ({ className = '', showLabel = true }) => {
  const { t } = useTranslation('common');

  return (
    <span className={`app-version-label${className ? ` ${className}` : ''}`}>
      {showLabel ? `${t('common.version')} ${APP_VERSION}` : APP_VERSION}
    </span>
  );
};

export default AppVersionLabel;